<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Media</span>
    <b-tabs card no-fade @input="reset">
      <b-tab title="All" active>
        <all ref="all"/>
      </b-tab>
      <b-tab title="<i class='fas fa-plus'></i> Add">
        <add ref="add"/>
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import add from './add'
import all from './all'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'

export default {
  components: {
    add,
    all,
    sidebar,
    page
  },
  methods: {
    reset (event) {
      if (!this.$refs.add.saving) {
        this.$refs.add.reset()
        this.$refs.add.typeSelection = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/media/index.vue